import { t } from 'i18next';

const PermissionDenied = () => {
  return (
    <>
      <h1>{t('PA_Permission_Denied')}</h1>
      <p>{t('PA_Please_contact')} support@syngenta.com</p>
    </>
  );
};

export default PermissionDenied;
